import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

// Uma das 3 colunas do rodape, encostada a direita. Enquanto Enviar para o
// Cliente e Fechar e Salvar estao ocultos, mantem o Fechar e Concluir do
// tamanho que ele tem com os tres botoes (32px = os dois gaps de 16px).
export const LastColumnSlot = styled.div.attrs({})`
  flex: 0 0 calc((100% - 32px) / 3);
  margin-left: auto;
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 20px 0px;
`;

// --- Coluna Oferta: card da oferta e card do resumo -----------------------
// O roxo vem da paleta do tema; os fundos claros sao o mesmo roxo em 10%.
const purple = (props) => props.theme.palette.purple.main;

const card = `
  border: 1px solid #ece8f7;
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
`;

export const OfferCard = styled.div.attrs({})`
  ${card}
`;

// O respiro de cima separa os rotulos do cabecalho do card.
export const OfferForm = styled.div.attrs({})`
  padding: 14px 16px 16px;
`;

// Switch "Dispensar mora", sob os campos da Oferta. So aparece com as flags do
// usuario e da distribuidora.
export const WaiverRow = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 16px;
  margin-top: 8px;
`;

export const WaiverNote = styled.span.attrs({})`
  font-size: 12px;
  color: #718096;
`;

export const SummaryCard = styled.div.attrs({})`
  ${card}
  margin-top: 12px;
`;

export const CardHeader = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid #eeeaf6;
  background: ${(props) =>
    props.$tinted ? 'rgba(123, 68, 242, 0.04)' : 'transparent'};
`;

export const HeaderIcon = styled.div.attrs({})`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: ${purple};
  background: rgba(123, 68, 242, 0.1);
`;

export const CardTitle = styled.h3.attrs({})`
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #1f1b2e;
`;

export const CardSubtitle = styled.p.attrs({})`
  margin: 0;
  font-size: 12px;
  color: #718096;
`;

export const CardBadge = styled.span.attrs({})`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: ${purple};
  background: rgba(123, 68, 242, 0.1);
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${purple};
  }
`;

export const FonteLink = styled.div.attrs({})`
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    color: #a0a0a0
    &:hover {
        color: #333333;
        background-color: #faf8f8;
    }
    &:active{
        color: #ffffff
        background-color: #2670D1;
    }
`;

export const ButtonsAndInputWrapper = styled.div.attrs({})`
  display: grid;
  gap: 20px;
`;
